(function (window, $) {
  var Ballyhoo = function (elem, options) {
    this.elem = elem;
    this.$elem = $(elem);
    this.options = options;
  };

  Ballyhoo.prototype = {

    defaults: {
      clientName: 'Fontainebleau Miami Beach',        // client name that goes in the bottom utility bar
      holder: $('.media-gallery'),                    // The DOM element that holds the galleria.
      splitCategory: true,                            // whether or not to have a single stream or not.
      dataSource: '',                                 // data source URL
      startCategory: '',                              // If splitCategory is true and this is set to a category then it will load that category by default, else it will show the tiles.
      splitMedia: true,                               // True: Adds the Photo/Video switch. False: Does not add the switch.
      initialMedia: 'photos',                         // 'photos' will load the photos by default and 'videos' will load the videos by default. This works regardless to whether you set splitmedia to true or not
      showInfo: false,                                // True: shows the title, rate and CTA area. False: Hides everything but the thumbnails
      showTiles: true                                 // True: Shows the Category Tiles on show, False: Skips the tiles be shown on load.
    },

    init: function () {
      this.config = $.extend({}, this.defaults, this.options);
      if (this.config.dataSource === '') {
        throw new Error('Missing dataSource. Kind of need that...');
      } else {
        this.show(this, this.config);
        return this;
      }
    },

    show: function (el, options) {
      el.loadGallery(options);
    },

    loadGallery: function (options) {
      var el = options.holder,
       media = {};

      $.getJSON(options.dataSource, function (response, e) {

        // The following was updated to fit the data structure coming from the custom admin for this site.
        // console.log('raw data from admin', response);
        var errors = response.data.errors.record,
         newData = [];

        var cmsData = response.data.data.record;

        if (cmsData.length === undefined) cmsData = fixArray(response.data.data.record);

        if (jQuery.isEmptyObject(response.data.errors)) {
          //var cmsData = response.data.data.record;

          $.each(cmsData, function (i, data) {
            var imageLists = data.content.imagelists.record,
             imageCategory = imageLists.name;

            // if there are multiple galleries for the same Gallery Type, then this becomes an array
            // temporary solution is to join the two galleries' files
            // with the first gallery acting as the single
            if ($.isArray(imageLists)) {
              var firstLists = imageLists[0];

              imageLists.forEach(function (list, i) {
                if (i === 0)
                  return true;

                firstLists.files.record = firstLists.files.record.concat(list.files.record);
              });

              imageLists = firstLists;
              imageCategory = firstLists.name;
            }

            $.each(imageLists.files.record, function (i, file) {
              var temp = [];

              temp['title'] = file.name;

              if (!jQuery.isEmptyObject(file.metadescription))
                temp['description'] = file.metadescription;
              else
                temp['description'] = file.description;

              if (file.filetype == 'Video') {
                temp['video'] = file.url;
              } else {
                temp['image'] = '/fontainebleau/' + file['@attributes'].id + '/19/' + file.filename;
                temp['thumb'] = '/fontainebleau/' + file['@attributes'].id + '/8/' + file.filename;
              }

              temp['category'] = imageCategory;

              if (!$.isEmptyObject(file.cta)) {
                var externalLink = false,
                 link = '#';

                if (file.cta.externalLink == "1")
                  externalLink = true;

                if (typeof file.cta.link === "string")
                  link = file.cta.link;

                temp['cta'] = {
                  "text": file.cta.text,
                  "activeText": file.cta.activeText,
                  "link": link,
                  "externalLink": externalLink
                };

                if (file.cta['@attributes']) {
                  // console.log(file.cta['@attributes'].type);
                  temp['cta']['type'] = file.cta['@attributes'].type;
                }
              }

              if (!$.isEmptyObject(file.rate)) {
                temp['rate'] = {
                  "cost": file.rate.cost,
                  "currency": file.rate.currency,
                };
              }

              if (!$.isEmptyObject(file.dining)) {
                temp['dining'] = file.dining['@attributes'].id;
              }

              if (!$.isEmptyObject(file.rooms)) {
                temp['rooms'] = [];
                temp['rooms'].push({
                  'typeid': file.rooms['@attributes'].typeid,
                  'name': file.rooms.name,
                  'record': fixArray(file.rooms.record)
                });
              }

              newData.push(temp);
            });

          });

          // console.log('raw data formatted for Galleria', newData);

          if (options.startCategory !== '') {
            media = $.grep(newData, function (e, i) {
              if (options.startCategory.toLowerCase() == e.category.toLowerCase()) {
                if (options.splitMedia) {
                  if (e.video && options.initialMedia == 'videos')
                    return e;
                  else
                    return e;
                } else {
                  return e;
                }
              }
            });
          } else {
            if (options.splitMedia) {
              media = $.grep(newData, function (e, i) {
                if (e.video && options.initialMedia == 'videos')
                  return e;
                else if (!e.video)
                  return e;
              });
            } else {
              media = newData;
            }
          }

          Galleria.loadTheme('/templates/main/js/themes/incontext/galleria.incontext.js');
          Galleria.loadTheme('/templates/main/js/incontext.gallery.js');
          el.addClass('show');
          $.ajax({
            url: '/templates/main/js/themes/incontext/templates/gallery-templates.html',
            cache: true,
            success: function (templates) {
              el.find('.galleria').galleria({
                dataSource: media,
                sabreConfig: {
                  clientName: options.clientName,
                  holder: options.holder,
                  splitCategory: options.splitCategory,
                  dataSource: newData,
                  startCategory: options.startCategory,
                  splitMedia: options.splitMedia,
                  initialMedia: options.initialMedia,
                  showInfo: options.showInfo,
                  rawData: newData,                                   // we use this so if the media object is filtered we have the original data object.
                  showTiles: options.showTiles,
                  templates: templates
                }
              });
            }
          });
        } else {
          throw new Error(errors['@attributes'].id + ': ' + errors.message);
        }
      });
    },

  };

  Ballyhoo.defaults = Ballyhoo.prototype.defaults;

  $.fn.ballyhoo = function (options) {
    return this.each(function () {
      new Ballyhoo(this, options).init();
    });
  };

  window.Ballyhoo = Ballyhoo;

})(window, jQuery);